import React from 'react';
import { motion } from 'framer-motion';
import { ImageIcon } from 'lucide-react';
interface PlaceholderGraphicProps {
  description: string;
  aspect?: 'wide' | 'square' | 'tall';
}
export function PlaceholderGraphic({
  description,
  aspect = 'wide'
}: PlaceholderGraphicProps) {
  const aspectClass = {
    wide: 'aspect-[16/7]',
    square: 'aspect-square',
    tall: 'aspect-[3/4]'
  }[aspect];
  return <motion.div initial={{
    opacity: 0,
    y: 12
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5
  }} className={`relative w-full ${aspectClass} max-h-[400px] rounded-xl border border-dashed border-picus-border/60 bg-gradient-to-br from-picus-surface/80 to-picus-bg overflow-hidden group`} data-id="element-317">
      {/* Grid pattern */}
      <div className="absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
      backgroundSize: '40px 40px'
    }} data-id="element-318" />

      {/* Subtle glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-picus-blue/5 rounded-full blur-3xl" data-id="element-319" />

      {/* Content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center p-8 text-center gap-4" data-id="element-320">
        <div className="w-10 h-10 rounded-lg border border-picus-border/40 bg-picus-surface/50 flex items-center justify-center" data-id="element-321">
          <ImageIcon className="w-5 h-5 text-picus-muted/60" data-id="element-322" />
        </div>
        <p className="text-sm text-picus-muted/70 max-w-md leading-relaxed font-medium" data-id="element-323">
          {description}
        </p>
      </div>

      {/* Corner accents */}
      <div className="absolute top-3 left-3 w-3 h-3 border-t border-l border-picus-border/30 rounded-tl" data-id="element-324" />
      <div className="absolute top-3 right-3 w-3 h-3 border-t border-r border-picus-border/30 rounded-tr" data-id="element-325" />
      <div className="absolute bottom-3 left-3 w-3 h-3 border-b border-l border-picus-border/30 rounded-bl" data-id="element-326" />
      <div className="absolute bottom-3 right-3 w-3 h-3 border-b border-r border-picus-border/30 rounded-br" data-id="element-327" />
    </motion.div>;
}